<script setup>
  import defaultImage from '@/assets/imgs/productDefault.png'
  import { getCurrentInstance, onMounted, ref, reactive, defineEmits, watch } from 'vue'
  import JLTools from '@/util/JLTools'

  const $emit = defineEmits(['click'])

  const props = defineProps({
    src: {
      type: [String, Array]
    },
    quality: {
      type: String,
      default: '85'
    },
    fit: {
      type: String
    },
    lazy: {
      type: Boolean,
      default: true
    }
  })

  watch(
    () => props.src,
    (newValue, oldValue) => {
      // console.log('更新图片')
      formatUrl()
    }
  )
  const loading = ref(true)
  const fitValue = ref(props.fit)
  const url = ref('')

  const formatUrl = () => {
    let value = props.src
    if (JLTools.isNull(value)) return
    if (String(value).indexOf('data:image') > -1 && String(value).indexOf('base64') > -1) {
      url.value = value
      return
    }
    url.value = JLTools.formatUrl(value)
    // console.log('图片地址', url.value)
  }

  const error = () => {
    url.value = defaultImage
    fitValue.value = 'contain'
  }

  const imgClick = ($event) => {
    $emit('click', $event)
  }

  onMounted(() => {
    // console.log('初始化')
    formatUrl()
  })
</script>

<template>
  <el-image :src="url" :fit="fitValue" @error="error" @click="imgClick" :lazy="props.lazy">
    <div slot="placeholder">
      <el-skeleton style="width: 100%" :loading="loading" animated :throttle="{ leading: 500, trailing: 500, initVal: true }">
        <template #template>
          <el-skeleton-item variant="image" style="width: 100%; height: 100%" />
        </template>
      </el-skeleton>
    </div>
  </el-image>
</template>

<style lang="less" scoped></style>
